<script setup lang="ts">
import type { CmsElementBuyBox } from '@shopware/composables'

const props = defineProps<{
    content: CmsElementBuyBox
}>()

// Still call useProduct to set up the context (ProductDetailVariants needs it
// via useProductConfigurator → useProduct() → injectLocal("product"))
useProduct(
    props.content.data.product,
    props.content.data.configuratorSettings || [],
)

// Writable ref — unlike the read-only computed returned by useProduct,
// this allows ProductDetailBuyBox to update the product via v-model without
// defineModel reverting it back to the original on every render cycle
const product = ref(props.content.data.product)
</script>

<template>
    <ProductDetailBuyBox
        v-if="product"
        v-model:product="product"
        :configurator="props.content.data.configuratorSettings"
    />
</template>